import gatewayRoutes from './gateway'
import endDeviceRoutes from './endDevice'
import multicastGroupRoutes from './multicastGroup'

const Fleets = () => import(/* webpackChunkName: "v-management" */ '@/components/page/fleets/Fleets')
const Gateways = () => import(/* webpackChunkName: "v-management" */ '@/components/page/Gateways')
const Clusters = () => import(/* webpackChunkName: "v-management" */ '@/components/page/clusters/Clusters')
const MulticastGroups = () => import(/* webpackChunkName: "v-management" */ '@/components/page/MulticastGroups')
const EndDevices = () => import(/* webpackChunkName: "v-management" */ '@/components/page/EndDevices')
const Kpi = () => import(/* webpackChunkName: "v-kpi" */ '@/components/page/kpi/Kpi')

const routes = [
  {
    path: 'fleets',
    component: Fleets,
    meta: {
      checkFleets: true
    }
  }, {
    path: 'gateways',
    component: Gateways,
    meta: {
      checkFleets: true
    }
  },
  ...gatewayRoutes,
  {
    path: 'clusters',
    component: Clusters,
    meta: {
      checkClusters: true
    }
  }, {
    path: 'multicast-groups',
    component: MulticastGroups,
    meta: {
      checkClusters: true
    }
  }, {
    path: 'end-devices',
    component: EndDevices,
    meta: {
      checkClusters: true
    }
  },
  ...multicastGroupRoutes,
  ...endDeviceRoutes,
  {
    // KPI page
    path: 'kpi',
    component: Kpi
  }
]

export default routes
